import { Circle, Icon, Text, VStack } from "@chakra-ui/react";
import TickIcon from "../../../assets/svg/tick-icon.svg?react";
import CustomButton from "../../../components/common/Button";
import { useNavigate } from "react-router-dom";
import { NAVIGATION_ROUTES } from "@/routes/constants";

const Submitted = () => {
  const navigate = useNavigate();
  return (
    <>
      <VStack gap={6} width={"50%"}>
        <Circle
          bg={"status.success"}
          maxHeight={"83px"}
          maxWidth={"83px"}
          p={3}
        >
          <Icon as={TickIcon} boxSize={8} />
        </Circle>
        <VStack gap={2}>
          <Text
            fontSize={"xl"}
            fontWeight={"bold"}
            color={"text.primary"}
            textAlign={"center"}
          >
            Your Document Has Been Successfully Submitted!
          </Text>
          <Text textAlign={"center"} fontSize={"md"} color={"text.secondary"}>
            Thank you for providing your document. We are currently in the
            process of reviewing it for verification. This process may take up
            to{" "}
            <Text
              as={"span"}
              fontWeight={"bold"}
              color={"brand.primary.DEFAULT"}
            >
              2 days
            </Text>
            . Once the verification is complete, you will receive a
            notification.
          </Text>
          <Text textAlign={"center"} fontSize={"md"} color={"text.secondary"}>
            For any updates, please check your account or contact our support
            team. We appreciate your patience!
          </Text>
        </VStack>
        <CustomButton
          fontSize="md"
          fontWeight="semibold"
          type="submit"
          fontFamily={"primary"}
          px={12}
          onClick={() => navigate(NAVIGATION_ROUTES.ADD_PRODUCT)}
        >
          Start Adding Product
        </CustomButton>
      </VStack>
    </>
  );
};
export default Submitted;
